import { FC } from 'react'
import {
  Box,
  Button,
  Dialog,
  Typography,
} from "@material-ui/core";
import cross from "../../assets/images/cross.svg";
import useStyles from "../Styles/ProjectModalStyles";
import { DeleteWalletProps } from "../../interfaces";


 
const ConfirmDeleteWallet: FC<DeleteWalletProps> = ({ open, setOpen, id, handleDelete }) => {
  const classes = useStyles();
  return (
    <>
      <Box component="section">
        <Dialog
          open={open}
          onClose={()=>setOpen(null)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={` ${classes.modalpages} ${classes.buymodal}`}
        >
          
            <Box className="relative-box" padding={"2.25rem"}>
              {(
                <img
                  src={cross}
                  alt=""
                  className="cross-icon"
                  style={{
                    top:15,
                    right:15,
                  }}
                  onClick={()=>setOpen(null)}
                />
              )}
              
              <Typography
                variant="h5"
                color="secondary"
                >
                  Are you sure you want to delete this wallet?
                  </Typography>

               
                  <Box  marginTop="2rem"> 
                  <Button
                   variant="contained"
                   color="secondary"
                   onClick={()=>handleDelete(id)}
                  
                  
                  >
                    Delete Wallet
                  </Button>
                  </Box>
              
            </Box>
          
        </Dialog>
      </Box>
    </>
  );
};

export default ConfirmDeleteWallet
